import qs from 'qs';

const DeactivationReason = {
    namespaced: true,

    state: {
        deactivationReasonData: [],
    },

    getters: {
        deactivationReasonData (state) {
            return state.deactivationReasonData;
        },
    },

    mutations: {

        /**
         * Установить значение причины деактивации
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['deactivationReasonData'] = items;
        },

        /**
         * Обновить значение элемента причины деактивации
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['deactivationReasonData'][index] = item;
        },

        /**
         * Добавить значение элемента причины деактивации
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['deactivationReasonData'].push(item);
        },

        /**
         * Удалить элемент из причины деактивации
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['deactivationReasonData'] = state['deactivationReasonData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по причинам деактивации
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getDeactivationReasonData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.deactivationReason,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по причинам деактивации получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN deactivationReason.js | getDeactivationReasonData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по причинам деактивации !'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по причинам деактивации
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveDeactivationReasonData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.deactivationReason,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по причинам деактивации успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.deactivationReasonId = response.data[0].deactivationReasonId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая причина деактивации успешно создана!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN deactivationReason.js | saveDeactivationReasonData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление причины деактивации
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeDeactivationReasonData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.deactivationReason,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Причина деактивациити успешно удалена!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении причины деактивации!'),
                    console.log('ERROR IN deactivationReason.js | removeDeactivationReasonData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default DeactivationReason;





// WEBPACK FOOTER //
// ./src/store/modules/deactivationReason.js